/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Case_Field_Driver_NameInputs */

const en_case_field_driver_name = /** @type {(inputs: Case_Field_Driver_NameInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Driver name`)
};

const pt_br2_case_field_driver_name = /** @type {(inputs: Case_Field_Driver_NameInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Nome do motorista`)
};

/**
* | output |
* | --- |
* | "Driver name" |
*
* @param {Case_Field_Driver_NameInputs} inputs
* @param {{ locale?: "en" | "pt-BR" }} options
* @returns {LocalizedString}
*/
export const case_field_driver_name = /** @type {((inputs?: Case_Field_Driver_NameInputs, options?: { locale?: "en" | "pt-BR" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Case_Field_Driver_NameInputs, { locale?: "en" | "pt-BR" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_case_field_driver_name(inputs)
	return pt_br2_case_field_driver_name(inputs)
});